
import React, { Component } from 'react'
import { Stepper, GetInfo } from '@operations/shared';
import UpdateUserCaps from './updateUserCaps';
import { getUserByPhoneApi } from '../../utils/apisConsts';

class ViewUpdateUserCaps extends Component{
    state = {
        componentSteps: [
            {
                title: 'Get User',
                content: <GetInfo apiLink={getUserByPhoneApi} />,
                id: 0,
            }, {
                title: 'Service Limit ',
                content: <UpdateUserCaps />,
                id: 1
            },
        ]
    }

    render() {
        const { componentSteps } = this.state;
        return (
            <>
                <Stepper componentSteps={componentSteps} />
            </>
        )
    }
}

export default ViewUpdateUserCaps
